module.exports = __webpack_public_path__ + "img/phoenix_kedel_3.bc90ba48.png";